import { defineComponent } from "vue";
import Debug from "@/shared/support/Debug";

// Static callback stored outside the component
let newPageShownCallback: (() => void) | null = null;

export default defineComponent({
    name: "PageBase",
    data() {
        return {
            loading: false,
            pageLoading: true,
            pageGone: false
        };
    },
    mounted() {
        Debug.verifyIds();
    },
    unmounted() {
        this.pageGone = true;
        // This is used by Auggie. The callback can be used to close any Help Modal that is displayed. This is
        // needed when the device is controlled remotely and a Help Modal happens to be up, we close them
        // whenever a new page is shown.
        if (newPageShownCallback) {
            newPageShownCallback();
        }
    }
});

// Export helper to set/get the static callback
export function setNewPageShownCallback(callback: (() => void) | null): void {
    newPageShownCallback = callback;
}

export function getNewPageShownCallback(): (() => void) | null {
    return newPageShownCallback;
}


